import "./App.css";
import { Schedule } from "./components/Schedule";

export const App = () => {
  return <Schedule />;
};
